<template>
  <div class="productList">
    <FilterOptions @filter="getProducts" class="options" />
    <div class="result">
      <product-tile
        v-for="(product, i) in products"
        :key="i"
        :data="product"
        @click="showProduct"
      />
    </div>
  </div>
</template>

<script>
import ProductTile from "../components/Product/ProductTile.vue";
import FilterOptions from "@/components/Product/FilterOptions.vue";
export default {
  data() {
    return {
      products: []
    };
  },
  methods: {
    getProducts(query) {
      this.axios.get(`product?${query}`).then(response => {
        this.products = [];
        this.products = response.data;
        // this.$set(this.products, response.data);
      });
    },
    showProduct(id) {
      this.$router.push({ path: "detail", query: { id } });
    }
  },
  created() {
    this.getProducts("");
  },
  components: {
    FilterOptions,
    ProductTile
  }
};
</script>

<style lang="scss" scoped>
.productList {
  display: grid;
  grid-template-columns: 1fr 2.9fr;
  .result {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;

    & > div {
      margin: 20px;
    }
  }
}
</style>
